module.exports = __webpack_public_path__ + "img/modelx2.8dbdf351.jpg";